import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import { Container, Box, CircularProgress } from '@mui/material';
import Menu from './components/Menu';
import Convidados from './components/Convidados';
import Fotografo from './components/Fotografo';
import Comida from './components/Comida';
import Decoracao from './components/Decoracao';
import Lembrancinha from './components/Lembrancinha';
import CaixasConvite from './components/CaixasConvite';
import Cerimonialista from './components/Cerimonialista';
import ChaPanela from './components/ChaPanela';
import ChaPanelaDesejos from './components/ChaPanelaDesejos';
import VestidoNoiva from './components/VestidoNoiva';
import Home from './components/Home';
import EspacoRecepcao from './components/EspacoRecepcao';
import DaminhaPajem from './components/DaminhaPajem';
import CursoNoivos from './components/CursoNoivos';
import Igreja from './components/Igreja';
import MakingOfNoiva from './components/MakingOfNoiva';
import OrcamentoDetalhado from './components/OrcamentoDetalhado';
import PagoFernando from './components/PagoFernando';
import AdminUsuarios from './components/AdminUsuarios';
import LogsAdmin from './components/LogsAdmin';
import axios from './api';

function App() {
  const [page, setPage] = useState('home');
  const [auth, setAuth] = useState({ loading: true, usuario: '', perfil: '' });

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setAuth({ loading: false, usuario: '', perfil: '' });
      return;
    }
    axios.get('/api/me')
      .then(res => {
        setAuth({ loading: false, usuario: res.data.usuario, perfil: res.data.perfil });
        localStorage.setItem('usuario', res.data.usuario);
        localStorage.setItem('perfil', res.data.perfil);
      })
      .catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('perfil');
        setAuth({ loading: false, usuario: '', perfil: '' });
      });
  }, []);

  const handleLogin = (usuario, perfil) => {
    setAuth({ loading: false, usuario, perfil });
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('perfil');
    setAuth({ loading: false, usuario: '', perfil: '' });
  };

  if (auth.loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!auth.usuario) {
    return <Login onLogin={handleLogin} />;
  }

  const isAdmin = auth.perfil === 'admin';
  const safePage = !isAdmin && ['OrcamentoDetalhado', 'pago_fernando', 'admin_usuarios', 'logs_admin', 'fotografo', 'comida', 'decoracao', 'lembrancinha', 'caixas_convite', 'cerimonialista', 'cha_panela', 'cha_panela_desejos', 'vestido_noiva', 'espaco_recepcao', 'daminha_pajem', 'curso_noivos', 'igreja', 'making_of_noiva'].includes(page)
    ? 'home'
    : page;

  return (
    <Container maxWidth="md">
      <Menu
        setPage={setPage}
        usuario={auth.usuario}
        perfil={auth.perfil}
        onLogout={handleLogout}
      />
      <Box sx={{ my: 4 }}>
        {safePage === 'home' && <Home setPage={setPage} isAdmin={isAdmin} />}
        {safePage === 'OrcamentoDetalhado' && isAdmin && <OrcamentoDetalhado />}
        {safePage === 'pago_fernando' && isAdmin && <PagoFernando />}
        {safePage === 'convidados' && <Convidados isAdmin={isAdmin} />}
        {safePage === 'fotografo' && isAdmin && <Fotografo />}
        {safePage === 'comida' && isAdmin && <Comida />}
        {safePage === 'decoracao' && isAdmin && <Decoracao />}
        {safePage === 'lembrancinha' && isAdmin && <Lembrancinha />}
        {safePage === 'caixas_convite' && isAdmin && <CaixasConvite />}
        {safePage === 'cerimonialista' && isAdmin && <Cerimonialista />}
        {safePage === 'cha_panela' && isAdmin && <ChaPanela />}
        {safePage === 'cha_panela_desejos' && isAdmin && <ChaPanelaDesejos />}
        {safePage === 'vestido_noiva' && isAdmin && <VestidoNoiva />}
        {safePage === 'espaco_recepcao' && isAdmin && <EspacoRecepcao />}
        {safePage === 'daminha_pajem' && isAdmin && <DaminhaPajem />}
        {safePage === 'curso_noivos' && isAdmin && <CursoNoivos />}
        {safePage === 'igreja' && isAdmin && <Igreja />}
        {safePage === 'making_of_noiva' && isAdmin && <MakingOfNoiva />}
        {safePage === 'admin_usuarios' && isAdmin && (
          <AdminUsuarios usuarioLogado={auth.usuario} />
        )}
        {safePage === 'logs_admin' && isAdmin && (
          <LogsAdmin />
        )}
      </Box>
    </Container>
  );
}

export default App;
